import { Component } from '@angular/core';

@Component({
  selector: 'app-new-gamification-card',
  templateUrl: './new-gamification-card.component.html',
  styleUrls: ['./new-gamification-card.component.css']
})
export class NewGamificationCardComponent {}
